import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

window.GLightbox = GLightbox;
